import { AnalyticalVariableListItem } from '@verantos-dev/feature-analytical-variables';
import { DataGrid, DataGridLayout } from '@verantos-dev/shared-components';

import { useAvLibrary } from '../hooks/useAvLibrary';
import { useAvLibraryDataGridFetch } from '../hooks/useAvLibraryDataGridFetch';

interface AvLibraryGridProps {
  onNameClick?: (analyticalVariable: AnalyticalVariableListItem) => void;
}

export const AvLibraryGrid = ({ onNameClick }: AvLibraryGridProps) => {
  const { columns, getRowId, sortModel, messages } = useAvLibrary({ onNameClick });

  return (
    <DataGridLayout id="av-library-list-content">
      <DataGrid
        id="av-library-grid"
        data-testid="av-library-MUIDataGrid"
        mode="server"
        getRowId={getRowId}
        columns={columns}
        messages={messages}
        useFetchDataGridData={useAvLibraryDataGridFetch}
        // Server-mode total: the grid's default ``getRowCount`` is
        // ``data.data.length`` (current page only), which under-reports the total
        // whenever a page doesn't contain every row — e.g. 95 rows shows "of 95"
        // at pageSize 100 but "of 25" at pageSize 25. Read the real server total.
        getRowCount={(data) => data.pagination.total}
        disableSearchParamSync
        pagination
        initialPageSize={100}
        initialState={{
          sorting: {
            sortModel,
          },
        }}
      />
    </DataGridLayout>
  );
};
